"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.styles = exports.StyledBadge = void 0;

var styled_1 = __importDefault(require("@emotion/styled"));

var material_1 = require("@mui/material");

exports.StyledBadge = (0, styled_1["default"])(material_1.Badge)(function (_a) {
  var theme = _a.theme;
  return {
    '& .MuiBadge-badge': {
      position: "absolute",
      bottom: "0.31rem",
      right: "0.31rem",
      backgroundColor: 'hsla(123, 46%, 34%, 1)',
      boxShadow: "0 0 0 .13rem white"
    }
  };
});
exports.styles = {
  small: {
    width: "2rem",
    height: "2rem"
  }
};